// extracted by mini-css-extract-plugin
export var active = "_23-d";
export var blink = "_23-e";
export var container = "_23-5";
export var controls = "_23-0";
export var controlsRight = "_23-1";
export var fakeCursor = "_23-c";
export var hidden = "_23-b";
export var quillContainerSmall = "_23-7";
export var quillEditor = "_23-6";
export var quillEditorSmall = "_23-8";
export var quillFormatButtons = "_23-a";
export var quillToolbar = "_23-9";
export var removePadding = "_23-2";
export var state = "_23-3";
export var stateTitle = "_23-4";